import { downloadSvg } from '~core';
import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';

export const saveSVG = () => {
  const metadata = getMetadata();

  const image = window.canvas.toSVG();

  const fileName = slugify(
    `${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }.svg`
  );

  downloadSvg(fileName, image);
};
